import {ajax} from 'rxjs/ajax';
import {map, timeout, catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs';
import {startAPI, endAPI, resetSessionTimeout} from 'redux/appAction';
import ObjectHelper from 'utils/ObjectHelper';
// import {startAPI, endAPI, resetSessionTimeout, startSaas, endSaas} from 'redux/appAction';
// import {logon} from 'redux/appAction';

import store from '../app/store';
import commonConfig from '../config/commonConfig';

import responseConverter from './apiResponseConverter';
import apiConfig from './apiConfig';

// const constructQueryString = (request) => {
//   if (request) {
//     const qstr = [];
//     for (const k in request) {
//       qstr.push(String(k) + '=' + encodeURIComponent(JSON.stringify(request[k])));
//     }
//     const qr = qstr.join('&');
//     return '?' + qr;
//   } else {
//     return '';
//   }
// };
const isDspLogon = ObjectHelper.isDspLogon();
console.log(isDspLogon, 'isDspLogon');

const parseUrlParam = (url, urlParam) => {
  let parsedUrl = url;
  if (urlParam) {
    for (const key in urlParam) {
      const rpKey = '{' + key + '}';
      const repEx = new RegExp(rpKey, 'g');
      parsedUrl = parsedUrl.replace(repEx, urlParam[key]);
    }
  }
  return parsedUrl;
};

const getCommsTokenFromUrl = () => {
  // logon api
  let saasTokenIdMatcher = /.*&?SAAS_TOKEN_ID=([^&]+).*/;
  let result = saasTokenIdMatcher.exec(document.URL);
  return (!!result && result[1]) || null;
};

const constructHeaders = (storeInfo, method) => {
  const {session} = store.getState();
  // @@WP-REACT: You may publish the header value from state.session or any data in state
  // ...

  let channel = 'OHI';
  let countryCode = 'AU';
  let locale = 'en_AU';
  let channelGroubMember = 'HKBA';
  let lob = 'PFS';
  if (session.header) {
    if (session.header.channel) {
      channel = session.header.channel;
    }
    if (session.header.countryCode) {
      countryCode = session.header.countryCode;
    }
    if (session.header.locale) {
      locale = session.header.locale;
    }
    if (session.header.channelGroubMember) {
      channelGroubMember = session.header.channelGroubMember;
    }
    if (session.header.lob) {
      lob = session.header.lob;
    }
  }
  const headers = {
    'Content-Type': 'application/json;',
    'X-HSBC-Lob': lob,
    'X-HSBC-Count': '1',
    'X-HSBC-Locale': locale,
    'X-HSBC-Channel-Id': channel,
    'X-HSBC-Chnl-CountryCode': countryCode,
    'X-HSBC-Chnl-Group-Member': channelGroubMember,
    // Authorization:
  };
  if (!isDspLogon) {
    headers.Authorization = sessionStorage.getItem('BEARER_TOKEN');
  }
  return headers;
};

const buildDummyUrl = (dummyUrlArr, apiUrl, statusCode, svcConfig, msgId) => {
  if (dummyUrlArr.length === 2) {
    statusCode = dummyUrlArr[0];
    apiUrl += dummyUrlArr[1];
  } else {
    apiUrl += svcConfig[msgId].url;
  }
};

const apiCall = (msgId, svcConfig, request, urlParam) => {
  store.dispatch(startAPI());
  store.dispatch(resetSessionTimeout());
  let apiUrl = svcConfig.svcHost + svcConfig[msgId].url;
  const apiMethod = svcConfig[msgId].method;
  apiUrl = parseUrlParam(apiUrl, urlParam);
  let wAjax = null;
  const reqHeader = constructHeaders(store, svcConfig[msgId].method);

  if (apiUrl.endsWith('.json')) {
    console.log('svcConfig[msgId].method--2', apiUrl, apiMethod);
    apiUrl = process.env.PUBLIC_URL + '/mock';
    const dummyUrlArr = svcConfig[msgId].url.split(':');
    const statusCode = 200;
    buildDummyUrl(dummyUrlArr, apiUrl, statusCode, svcConfig, msgId);
    wAjax = ajax({
      url: apiUrl,
      method: 'GET',
      headers: {...reqHeader, 'rxjs-hdr-status': statusCode},
      withCredentials: false,
    });
  } else if (svcConfig[msgId].method === 'GET') {
    // console.log('request', request);
    // const qs = constructQueryString(request);

    const qs = request.data;
    wAjax = ajax({
      url: apiUrl + qs,
      method: apiMethod,
      headers: reqHeader,
      withCredentials: isDspLogon,
      responseType: msgId === 'downloadFile' ? 'arraybuffer' : 'json',
    });
  } else if (svcConfig[msgId].method === 'LOGON') {
    let commsToken = getCommsTokenFromUrl();
    const headers = {
      'Content-Type': 'application/json;',
      'X-HSBC-Locale': 'en-us',
      'X-HSBC-Channel-Id': 'WEB',
      'X-HSBC-Chnl-CountryCode': 'AU',
      'X-HSBC-Chnl-Group-Member': 'HKBA',
      client_id: commonConfig.saas.client_id,
      client_secret: commonConfig.saas.client_secret,
    };
    if (!isDspLogon) {
      headers.Authorization = 'Comms ' + commsToken;
    }
    wAjax = ajax({
      url: apiUrl,
      method: 'GET',
      headers,
      withCredentials: isDspLogon,
    });
  } else if (svcConfig[msgId].method === 'SAAS') {
    const anonymousCommsTokenHeaders = {
      client_id: commonConfig.saas.client_id,
      client_secret: commonConfig.saas.client_secret,
      Accept: commonConfig.saas.Accept,
    };
    let saasUrl = commonConfig.saas.anonymousCommsTokenUrl + '?' + request;
    wAjax = ajax({
      url: saasUrl,
      method: 'GET',
      headers: anonymousCommsTokenHeaders,
      withCredentials: false,
    });
  } else if (svcConfig[msgId].method === 'DSP') {
    const dspAnonymousJWTTokenHeaders = {
      'content-type': 'application/json',
      'cache-control': 'no-cache',
    };
    const dspUrl = commonConfig.dsp.anonymousCommsTokenUrl;
    wAjax = ajax({
      url: dspUrl,
      method: 'POST',
      headers: dspAnonymousJWTTokenHeaders,
      body: JSON.stringify(request),
      withCredentials: false,
    });
  } else if (svcConfig[msgId].method === 'POST' || svcConfig[msgId].method === 'PUT') {
    // eslint-disable-next-line no-debugger
    wAjax = ajax({
      url: apiUrl,
      method: apiMethod,
      headers: reqHeader,
      body: JSON.stringify(request),
      withCredentials: isDspLogon,
    });
  } else if (svcConfig[msgId].method === 'UPLOAD') {
    const headers = {
      'X-HSBC-Chnl-Group-Member': 'HKBA',
      'X-HSBC-Locale': 'en_AU',
      'x-hsbc-chnl-countryCode': 'AU',
      'x-hsbc-channel-id': 'OHI',
      'x-hsbc-lob': 'PFS',
      'x-hsbc-count': '1',
    };
    if (!isDspLogon) {
      headers.Authorization = sessionStorage.getItem('BEARER_TOKEN');
    }
    wAjax = ajax({
      url: apiUrl,
      method: 'POST',
      headers: headers,
      body: request,
      withCredentials: isDspLogon,
    });
  }
  // @@WP-REACT: supplement more request method like  DELETE, PATCH etc if need
  // ...

  const apiTimeout = svcConfig[msgId].timeout ? svcConfig[msgId].timeout : apiConfig.timeout;

  return wAjax.pipe(timeout(apiTimeout));
};

const apiService = (msgId, svcConfig, request, urlParam) =>
  apiCall(msgId, svcConfig, request, urlParam)
    .pipe(
      finalize(() => {
        store.dispatch(endAPI());
      }),
    )
    .pipe(
      map((rxResponse) => {
        const wResponse = responseConverter(rxResponse, msgId);
        return wResponse;
      }),
      catchError((rxError) => {
        // store.dispatch(finishApi());
        // console.log('rxError', rxError, rxError.xhr.responseURL);
        const {app} = store.getState();
        console.log('saasInflightend', app);
        const error = responseConverter(rxError, msgId);
        return of(error);
      }),
    );

export default apiService;
